import { render, staticRenderFns } from "./ContentTemp.vue?vue&type=template&id=623826ac&scoped=true&"
import script from "./ContentTemp.vue?vue&type=script&lang=js&"
export * from "./ContentTemp.vue?vue&type=script&lang=js&"
import style0 from "./ContentTemp.vue?vue&type=style&index=0&id=623826ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623826ac",
  null
  
)

export default component.exports